module.exports = {
	backdrop: {
    isShowing: false,
	  show: function (target, messageRenderId) {
      if (this.isShowing) {
        return
      }
      // 
	    let opts = {
	      lines: 14, // The number of lines to draw
	      length: 28, // The length of each line
	      width: 14, // The line thickness
	      radius: 42, // The radius of the inner circle
	      scale: 1, // Scales overall size of the spinner
	      corners: 1, // Corner roundness (0..1)
	      color: '#fff', // #rgb or #rrggbb or array of colors
	      opacity: 0.25, // Opacity of the lines
	      rotate: 0, // The rotation offset
	      direction: 1, // 1: clockwise, -1: counterclockwise
	      speed: 1, // Rounds per second
	      trail: 60, // Afterglow percentage
	      fps: 20, // Frames per second when using setTimeout() as a fallback for CSS
	      zIndex: 2e9, // The z-index (defaults to 2000000000)
	      className: 'spinner', // The CSS class to assign to the spinner
	      top: '50%', // Top position relative to parent
	      left: '50%', // Left position relative to parent
	      shadow: false, // Whether to render a shadow
	      hwaccel: false, // Whether to use hardware acceleration
	      position: 'fixed' // Element positioning      
	    }
      // 
      if (messageRenderId) {
        messageRender = document.querySelector('#message-render-' + messageRenderId)
        messageRender.style.top = '0'
        messageRender.style.zIndex = '199'        
      }
      //
	    let targetEl = document.querySelector(target) 
	    //   
	    targetEl.style.zIndex = '200'
	    targetEl.style.position = 'fixed'
	    let documentBody = document.querySelector('body')
	    let backdrop = document.createElement('DIV')
	    backdrop.setAttribute('id', 'backdrop')
	    // 
	    window.spinner = new Spinner(opts).spin(targetEl)
	    targetEl.appendChild(backdrop)
      backdrop.style.backgroundColor = '#000000'
      backdrop.style.opacity = '0.55'
	    backdrop.style.width = '100%'
	    backdrop.style.height = '100%'
	    backdrop.style.position = 'fixed'
	    backdrop.style.top = '0'
	    backdrop.style.left = '0'
	    backdrop.style.zIndex = '1999999999'
      this.isShowing = true
	  },
    // 
	  hide: function (target, messageRenderId) {
      if (!this.isShowing) {
        return
      }
      // 
      console.log('/////////////////////////////// hide')
      if (messageRenderId) {
        messageRender = document.querySelector('#message-render-' + messageRenderId)
        if (messageRender) {
          messageRender.style.top = '-10000px'
          messageRender.style.zIndex = '10'     
        }
      }
	    let targetEl = document.querySelector(target)
      let elementBackdrop = targetEl.querySelector('#backdrop')
      if (elementBackdrop) {
        targetEl.removeChild(elementBackdrop)
      }
	    window.spinner.stop()
	    targetEl.removeAttribute('style')
      this.isShowing = false
	  }   
	}
}




//////////////////
// WEBPACK FOOTER
// ./~/annonces-app-modules/controllers/Helper.js
// module id = 79
// module chunks = 0